import { useIntl } from 'react-intl'
import NotFoundComponent from '../../../../../components/stories/molecules/not-found'
import { EmptyContent, NotFoundContainer } from '../../../styled-component'
import { textStyleSizeOptions } from '../../../../../components/stories/fundamentals/text-styles/constants'

const PlanMenuTileEmptySearch = () => {
  const { formatMessage } = useIntl()

  return (
    <NotFoundContainer>
      <EmptyContent>
        <NotFoundComponent
          header={formatMessage({ id: 'pinList_noResult' })}
          headerSize={textStyleSizeOptions['TEXT-XXL']}
          description={formatMessage({ id: 'not_found_description' })}
          descriptionSize={textStyleSizeOptions['TEXT-L']}
        />
      </EmptyContent>
    </NotFoundContainer>
  )
}

export default PlanMenuTileEmptySearch
